import React from "react";
import whiteMakecodeSVG from "./makecode_16x_white.svg";
import colorMakecodeSVG from "./makecode_16x.svg";

interface MakecodeSVGProps {
  width: number;
  height: number;
  choice: string;
}

export const makeCodeSvgColor = colorMakecodeSVG;
export const makeCodeSvgWhite = whiteMakecodeSVG;

const MakecodeSVG = ({ height, width, choice }: MakecodeSVGProps) => (
  <img
    height={height}
    width={width}
    src={choice === "colour" ? colorMakecodeSVG : whiteMakecodeSVG}
    alt=""
  />
);

export default MakecodeSVG;
